import React from 'react';
import FeedbackSection from './FeedbackSection';
import { useFeedback } from '../FeedbackProvider';
import FeedbackAwaiting from 'donor/portal/pages/FeedbackDashboard/Feedback/FeedbackAwaiting';

const Feedback: React.FC = () => {
  const { pathname } = window.location;
  const { feedback, userStaticType } = useFeedback();

  switch (feedback.status) {
    case 'TI Feedback Provided':
    case 'Funder Feedback Provided':
      if (userStaticType === 'npo' || userStaticType === 'cn-npo') {
        return <FeedbackSection />;
      }
      break;

    case 'Awaiting TI Verification':
    case 'Awaiting Funder Verification':
      if (
        (userStaticType === 'ti staff' || userStaticType === 'donor') &&
        !pathname.includes('/npo/')
      ) {
        return <FeedbackSection />;
      }
      break;
  }
  return (
    <FeedbackAwaiting
      userType={userStaticType}
      feedbackStatus={feedback.status}
    />
  );
};

export default React.memo(Feedback);
